export default "__VITE_ASSET__D33P7z$o__"